var _excluded = ["min", "max", "step", "grid", "grid_num", "from", "skin", "postfix"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * This component is based off the IonRangeSlider
 * https://www.npmjs.com/package/react-ion-slider
 **/

import IonRangeSlider from "react-ion-slider";
var RangeSlider = function RangeSlider(_ref) {
  var min = _ref.min,
    max = _ref.max,
    step = _ref.step,
    grid = _ref.grid,
    grid_num = _ref.grid_num,
    from = _ref.from,
    skin = _ref.skin,
    postfix = _ref.postfix,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(IonRangeSlider, Object.assign({
    min: min,
    max: max,
    step: step,
    grid: grid,
    grid_num: grid_num,
    postfix: postfix,
    from: from,
    skin: skin
  }, rest));
};
RangeSlider.defaultProps = {
  min: 1,
  max: 10,
  step: 1,
  grid: true,
  grid_num: 9,
  from: 6,
  skin: 'round'
};
export default RangeSlider;